module.exports = __webpack_public_path__ + "static/media/Bahamas.a1697e40.png";